module.exports = __webpack_public_path__ + "img/oil-can-drip.e3f9ec73.svg";